/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tb_Example_MilestoneInputs */

const en_mk_tb_example_milestone = /** @type {(inputs: Mk_Tb_Example_MilestoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Milestone: first shared release`)
};

const id_mk_tb_example_milestone = /** @type {(inputs: Mk_Tb_Example_MilestoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Milestone: rilis pertama bersama`)
};

/**
* | output |
* | --- |
* | "Milestone: first shared release" |
*
* @param {Mk_Tb_Example_MilestoneInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tb_example_milestone = /** @type {((inputs?: Mk_Tb_Example_MilestoneInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tb_Example_MilestoneInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tb_example_milestone(inputs)
	return en_mk_tb_example_milestone(inputs)
});